
import { Component, Vue, Prop } from 'vue-property-decorator';
import TextButton from '../../shared/suites/TextButton.vue';

@Component<RotationalMenuCard>({
	components: {
		TextButton
	}
})
export default class RotationalMenuCard extends Vue {
	@Prop({ type: Object, required: true }) private rotationalMenu!: DailyMenu;

	private sortedMenuItems(menu: Menu): MenuItem[] {
		return menu.items?.slice().sort((a: MenuItem, b: MenuItem) => {
			if (a.published_at && !b.published_at) {
				return -1;
			}
			else if (!a.published_at && b.published_at) {
				return 1;
			}
			return a.order - b.order;
		}) || [];
	}
}
